<template>
    <v-card elevation="0">
        <v-card-title class="mt-n2">
            <div class="headline">{{$t('app_drawer.company')}}</div>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.push({name: 'company-add'})">
                {{$t('company.create')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="pb-8">
                    <v-text-field v-model="search"
                                append-icon="mdi-magnify"
                                :label="$t('search')"
                                single-line
                                hide-details>
                    </v-text-field>
                </v-col>
                <v-col v-show="$vuetify.breakpoint.smAndUp">
                </v-col>
            </v-row>
            
            <v-data-table :headers="headers"
                        :items="companies"
                        :search="search">
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.updatedAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                        @click="$router.push({name: 'company-edit', params: {companyId:item.id}})">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'CompanyList',
        setup(props, {root}) {
            const {Company} = root.$FeathersVuex.api;

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});


            // Data Table
            const search = ref('');
            const headers = ref([
                {text: root.$t('company.name'), value: 'name'},
                {text: root.$t('company.domain'), value: 'domain'},
                {text: root.$t('company.created_at'), value: 'createdAt', filterable: false},
                {text: root.$t('company.updated_at'), value: 'updatedAt', filterable: false},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);

            return {
                companies: companyData.items,

                search,
                headers,

                DateTime,
            }
        }
    }
</script>
